import React, { useEffect, useState } from "react";
import { Button, Form } from "antd";
import type { FormInstance } from "antd";
import { observer } from "mobx-react-lite";
import { PrintWaybillFormValues } from "../PrintWaybillForm";
import { prefixCacheKey } from "@/scenes/OrderManagement/components/dialogs/PrintWaybillDialog/components/AdvancedSettingFormItem";
import IgnoreDuplicateOrderValidationFormItem from "@/scenes/OrderManagement/components/dialogs/PrintWaybillDialog/components/AdvancedSettingFormItems/IgnoreDuplicateOrderValidationFormItem";
import ProcessInRangeFormItem from "@/scenes/OrderManagement/components/dialogs/PrintWaybillDialog/components/AdvancedSettingFormItems/ProcessInRangeFormItem";

interface AdvancedSettingFormItemProps {
    form?: FormInstance<PrintWaybillFormValues>;
    showProcessInRange?: boolean;
}

/**
 * 高级选项表单
 */
const AdvancedSettingFormItem: React.FC<AdvancedSettingFormItemProps> = function (props) {
    const { form, showProcessInRange } = props;
    const [show, setShow] = useState(false);

    useEffect(() => {
        const show = localStorage.getItem(`${prefixCacheKey}show`) === "true";

        /** 如果勾选选项，也默认展开 */

        const ignoreDuplicateOrderValidation = localStorage.getItem(`${prefixCacheKey}ignoreDuplicateOrderValidation`);

        if (show || !!ignoreDuplicateOrderValidation) {
            setShow(true);
        }
    }, []);

    return (
        <Form.Item
            label={
                <>
                    <span>高级选项</span>
                    <Button
                        type="link"
                        className="ml3"
                        onClick={() => {
                            const checked = !show;

                            setShow(checked);

                            localStorage.setItem(`${prefixCacheKey}show`, checked.toString());
                        }}
                    >
                        {show ? "收起" : "展开"}
                    </Button>
                </>
            }
        >
            <div style={{ marginTop: 6, display: show ? "block" : "none" }}>
                <IgnoreDuplicateOrderValidationFormItem form={form} />
                {showProcessInRange ? <ProcessInRangeFormItem form={form} /> : null}
            </div>
        </Form.Item>
    );
};

export default observer(AdvancedSettingFormItem);
